

(function () {
  'use strict';

  // 2026-10-31: this file is included by the cart drawer and by every section
  // with quick-add cards, and each <script> tag re-ran this IIFE: 3x cart
  // subscriptions meant 3 /cart.js fetches per add. init() already covers every
  // .wc-quick-add on the page (and appended ones), so one run is enough.
  if (window.__wcQuickAddLoaded) return;
  window.__wcQuickAddLoaded = true;

  
  var productCache = {};

  
  var SIZE_MAP = {
    'X-Small': 'XS', 'Small': 'S', 'Medium': 'M',
    'Large': 'L', 'X-Large': 'XL', '2XL': '2XL', 'XX-Large': '2XL', '3XL': '3XL'
  };

  
  function init() {
    document.querySelectorAll('.wc-quick-add').forEach(function (container) {
      
      if (container.dataset.wcInitialized) return;
      container.dataset.wcInitialized = 'true';

      var btn = container.querySelector('.wc-quick-add__btn');
      var handle = container.dataset.productHandle;
      var singleVariant = container.dataset.singleVariant;

      if (!btn || !handle) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (singleVariant) {
          addToCart(container, singleVariant);
          return;
        }
        // Collection size filter active — wc-size-filter.js stamps
        // data-wc-quick-size on the filtered grid's cards only (never the
        // cart-recs cards). The shopper already chose a size, so add it
        // straight to cart and skip the picker.
        var quickSize = container.dataset.wcQuickSize;
        if (quickSize) {
          quickAddSize(container, handle, quickSize);
          return;
        }
        showSizes(container, handle);
      });
    });

    
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.wc-quick-add')) {
        document.querySelectorAll('.wc-quick-add__sizes:not([hidden])').forEach(function (el) {
          el.setAttribute('hidden', '');
          el.innerHTML = '';
          var btn = el.closest('.wc-quick-add').querySelector('.wc-quick-add__btn');
          if (btn) btn.removeAttribute('hidden');
        });
      }
    });
  }

  
  function showSizes(container, handle) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');
    if (!sizesEl) return;

    
    var embeddedData = container.dataset.variants;
    if (embeddedData) {
      try {
        var variants = JSON.parse(embeddedData);
        renderSizeButtons(container, variants);
        return;
      } catch (e) {
        console.error('[WC Quick Add] Failed to parse embedded variants:', e);
      }
    }

    
    btn.textContent = '...';
    btn.setAttribute('disabled', '');

    if (productCache[handle]) {
      renderSizeButtons(container, productCache[handle].variants);
      return;
    }

    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productCache[handle] = data.product;
        renderSizeButtons(container, data.product.variants);
      })
      .catch(function (err) {
        console.error('[WC Quick Add] Fetch error:', err);
        btn.textContent = defaultBtnLabel(container);
        btn.removeAttribute('disabled');
      });
  }

  // Resting label for the quick-add button — includes the size when the
  // collection size filter is active or the cart-size signal is set.
  // S/M/L get spelled out ("+ Quick Add Small") for warmer copy; XL/2XL/XS
  // stay as abbreviations (spelled-out "extra-large" reads awkwardly).
  // CSS text-transform: uppercase on .wc-quick-add__btn handles the casing
  // so the final rendered text reads "+ QUICK ADD SMALL", "+ QUICK ADD XL".
  // SIZE_LABELS is defined later in this IIFE but `var` hoisting makes the
  // identifier available; the assignment runs before defaultBtnLabel is
  // ever called (init/applyTreatment are kicked off via DOMContentLoaded
  // or microtask after the whole IIFE has finished evaluating).
  function defaultBtnLabel(container) {
    var qs = container && container.dataset.wcQuickSize;
    if (!qs) return '+ Quick Add';
    var label = (SIZE_LABELS[qs] && SIZE_LABELS[qs][0]) || qs;
    return '+ Quick Add ' + label;
  }

  // Filtered-collection fast path — add the filter's size straight to the
  // cart, no picker. Falls back to the picker if that size can't be
  // resolved (shouldn't happen: the filter only surfaces in-stock sizes).
  function quickAddSize(container, handle, sizeAbbr) {
    var btn = container.querySelector('.wc-quick-add__btn');
    function pick(variants) {
      var match = null;
      variants.forEach(function (v) {
        if (match) return;
        var sizeName = v.option1 || v.title;
        var abbr = SIZE_MAP[sizeName] || sizeName;
        if (abbr === sizeAbbr && v.available) match = v;
      });
      if (match) {
        addToCart(container, match.id, sizeAbbr);
      } else {
        showSizes(container, handle);
      }
    }
    var embedded = container.dataset.variants;
    if (embedded) {
      try { pick(JSON.parse(embedded)); return; }
      catch (e) { console.error('[WC Quick Add] Failed to parse embedded variants:', e); }
    }
    if (productCache[handle]) { pick(productCache[handle].variants); return; }
    if (btn) { btn.textContent = '...'; btn.setAttribute('disabled', ''); }
    fetch('/products/' + handle + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productCache[handle] = data.product;
        if (btn) { btn.textContent = defaultBtnLabel(container); btn.removeAttribute('disabled'); }
        pick(data.product.variants);
      })
      .catch(function (err) {
        console.error('[WC Quick Add] Fetch error:', err);
        if (btn) { btn.textContent = defaultBtnLabel(container); btn.removeAttribute('disabled'); }
      });
  }

  function renderSizeButtons(container, variants) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');

    
    btn.setAttribute('hidden', '');

    
    var html = '';
    variants.forEach(function (variant) {
      var sizeName = variant.option1 || variant.title;
      var abbr = SIZE_MAP[sizeName] || sizeName;
      var available = variant.available;
      html += '<button type="button" class="wc-quick-add__size-btn' +
        (!available ? ' wc-quick-add__size-btn--unavailable' : '') +
        '" data-variant-id="' + variant.id + '"' +
        (!available ? ' disabled' : '') +
        '>' + abbr + '</button>';
    });
    sizesEl.innerHTML = html;
    sizesEl.removeAttribute('hidden');

    
    sizesEl.querySelectorAll('.wc-quick-add__size-btn').forEach(function (sizeBtn) {
      sizeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (sizeBtn.hasAttribute('disabled')) return;
        addToCart(container, sizeBtn.dataset.variantId, sizeBtn.textContent);
      });
    });
  }

  function addToCart(container, variantId, sizeName) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');
    var statusEl = container.querySelector('.wc-quick-add__status');

    
    if (btn) btn.setAttribute('hidden', '');
    if (sizesEl) sizesEl.setAttribute('hidden', '');
    if (statusEl) {
      statusEl.removeAttribute('hidden');
      statusEl.className = 'wc-quick-add__status wc-quick-add__status--adding';
      statusEl.textContent = 'Adding...';
    }

    // 2026-10-31: from a collection card (bag closed), open the bag right away
    // with a pending row instead of after Shopify answers. Recs inside an
    // already-open bag keep their own "Adding..." label.
    var drawer = document.querySelector('cart-drawer');
    var pending = !!(drawer && typeof drawer.showPending === 'function' && !drawer.classList.contains('active'));
    if (pending) {
      var card = container.closest('.card-wrapper, .card, li, .grid__item') || container;
      var heading = card.querySelector('.card__heading, .card__information h3, h3');
      var cardImg = card.querySelector('img');
      drawer.showPending({
        title: heading ? heading.textContent.trim() : '',
        size: sizeName || '',
        image: cardImg ? (cardImg.currentSrc || cardImg.src) : ''
      });
    }


    var body = JSON.stringify({
      items: [{ id: parseInt(variantId), quantity: 1 }]
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          if (pending) drawer.clearPending(true, response.description);
          showError(container, response.description || 'Error adding to cart');
          return;
        }
        // Cycle 60: Clarity events (no-ops without Clarity). Drawer recs also send wc_rec_add.
        if (window.wcTrack) {
          window.wcTrack('wc_quick_add');
          if (container.closest && container.closest('cart-drawer')) window.wcTrack('wc_rec_add');
        }

        
        if (statusEl) {
          statusEl.className = 'wc-quick-add__status wc-quick-add__status--added';
          statusEl.textContent = '\u2713 Added' + (sizeName ? ' \u00b7 ' + sizeName : '');
        }


        fetchCartAndOpenDrawer();


        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'wc-quick-add',
            productVariantId: variantId,
            cartData: response
          });
        }

        
        setTimeout(function () {
          resetToDefault(container);
        }, 1500);
      })
      .catch(function (err) {
        console.error('[WC Quick Add] Cart add error:', err);
        if (pending) drawer.clearPending(true);
        showError(container, 'Error adding to cart');
      });
  }

  // Q1 Tier-1: the cart-drawer + cart-icon-bubble sections are fetched in
  // PARALLEL and the drawer opens as soon as the swap lands - no chained
  // bubble fetch, no arbitrary 100ms wait (the original needless lag).
  function fetchCartAndOpenDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    function applyDrawerHtml(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var newInner = parsed.querySelector('.drawer__inner');
      var curInner = document.querySelector('.drawer__inner');
      if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
      cartDrawer.classList.remove('is-empty');
      if (typeof cartDrawer.clearPending === 'function') cartDrawer.clearPending();
      var overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay && !overlay.dataset.wcCloseBound) {
        overlay.dataset.wcCloseBound = '1';
        overlay.addEventListener('click', function () { cartDrawer.close(); });
      }
      if (typeof cartDrawer.open === 'function') cartDrawer.open();
    }
    function applyBubbleHtml(html) {
      var pb = new DOMParser().parseFromString(html, 'text/html');
      var nb = pb.querySelector('.shopify-section') || pb.body.firstElementChild;
      var cb = document.getElementById('cart-icon-bubble');
      if (nb && cb) cb.innerHTML = nb.innerHTML;
    }

    fetch('/cart?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(applyBubbleHtml)
      .catch(function () { /* bubble is cosmetic */ });
    fetch('/cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(applyDrawerHtml)
      .catch(function (err) { console.error('[WC Quick Add] Cart drawer update error:', err); });
  }

  
  function resetToDefault(container) {
    var btn = container.querySelector('.wc-quick-add__btn');
    var sizesEl = container.querySelector('.wc-quick-add__sizes');
    var statusEl = container.querySelector('.wc-quick-add__status');

    if (btn) {
      btn.textContent = defaultBtnLabel(container);
      btn.removeAttribute('disabled');
      btn.removeAttribute('hidden');
    }
    if (sizesEl) {
      sizesEl.setAttribute('hidden', '');
      sizesEl.innerHTML = '';
    }
    if (statusEl) {
      statusEl.setAttribute('hidden', '');
      statusEl.textContent = '';
    }
  }

  function showError(container, message) {
    var statusEl = container.querySelector('.wc-quick-add__status');
    if (statusEl) {
      statusEl.className = 'wc-quick-add__status wc-quick-add__status--error';
      statusEl.textContent = message;
    }
    setTimeout(function () { resetToDefault(container); }, 2000);
  }

  
  /* ── Site-wide size treatment ──────────────────────────────────────────
   * Once a shopper has a known size — a collection size filter, or a sized
   * shirt already in their cart — every quick-add button becomes
   * "+ Quick Add <SIZE>" and a tap adds that size with no picker. Catches
   * shoppers who never touch the filter. Non-sized products (stickers,
   * magnets) and cards sold out in that size keep the plain picker flow.
   * XS is deliberately excluded — it's being phased out, never a trigger.
   */
  var WC_SIZES = ['S', 'M', 'L', 'XL', '2XL'];
  var currentCartSize = null;
  var currentCartSizes = [];   // every S/M/L/XL/2XL present in the cart (for rec tiering)

  // Dominant cart size, counting only S/M/L/XL/2XL. XS and unsized items
  // never count — an XS-only cart yields null, so no treatment fires.
  function computeCartSize(cart) {
    var tally = {};
    var items = (cart && cart.items) || [];
    items.forEach(function (item) {
      (item.options_with_values || []).forEach(function (opt) {
        if (!opt || opt.name !== 'Size') return;
        var abbr = SIZE_MAP[opt.value] || opt.value;
        if (WC_SIZES.indexOf(abbr) === -1) return;
        tally[abbr] = (tally[abbr] || 0) + (item.quantity || 0);
      });
    });
    currentCartSizes = WC_SIZES.filter(function (s) { return (tally[s] || 0) > 0; });
    var best = null, bestN = 0;
    WC_SIZES.forEach(function (s) {
      if ((tally[s] || 0) > bestN) { bestN = tally[s]; best = s; }
    });
    return best;
  }

  // Effective size = the collection filter if active on this page,
  // otherwise the cart's dominant size.
  function effectiveSize() {
    var fromFilter = null;
    try { fromFilter = new URLSearchParams(location.search).get('wc-size'); }
    catch (e) {}
    if (fromFilter && WC_SIZES.indexOf(fromFilter) > -1) return fromFilter;
    return currentCartSize;
  }

  // Pluralized human-friendly size word for the "Only N <size> left" badge.
  // S/M/L spell out (small/smalls etc). XL/2XL/XS keep the abbreviation
  // because spelled-out versions ("extra-larges") read awkwardly.
  var SIZE_LABELS = {
    'S':   ['small',  'smalls'],
    'M':   ['medium', 'mediums'],
    'L':   ['large',  'larges'],
    'XL':  ['XL',     'XLs'],
    '2XL': ['2XL',    '2XLs'],
    'XS':  ['XS',     'XSs']
  };
  function sizeWord(size, count) {
    var w = SIZE_LABELS[size] || [size, size + 's'];
    return count === 1 ? w[0] : w[1];
  }

  // Number words for the count slot, used only when the size keeps its
  // abbreviation (XS/XL/2XL). Reason: "Only 2 XLs left" creates a visual
  // jumble where the digit runs straight into the next digit/letter; spelling
  // it out ("Only two XLs left") reads cleaner. For S/M/L the spelled-out
  // size word ("smalls") separates the digit, so the numeral stays.
  var NUMBER_WORDS = {
    1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five',
    6: 'six', 7: 'seven', 8: 'eight', 9: 'nine'
  };
  function countLabel(count, size) {
    var spellOut = (size === 'XS' || size === 'XL' || size === '2XL');
    return (spellOut && NUMBER_WORDS[count]) ? NUMBER_WORDS[count] : String(count);
  }


  // Shared injection — used for both card-context (collection grid, recs,
  // related products, etc.) and PDP-context (main product image overlay).
  // Logic is identical; only difference is the visual modifier ('card' vs
  // 'pdp') and the fallback insertion point when there's no existing static
  // badge to swap with.
  function injectLowStockBadge(container, size, contextMod) {
    if (!container) return;
    // Clean prior state first — idempotent so repeated calls don't accumulate.
    var prior = container.querySelector('.wc-low-stock-flag');
    if (prior) prior.remove();
    container.querySelectorAll('.wc-vbadge[data-wc-suppressed]').forEach(function (b) {
      b.removeAttribute('data-wc-suppressed');
      b.style.display = '';
    });
    if (!size) return;
    var ls = container.getAttribute('data-wc-low-stock') || '';
    if (!ls) return;
    var tokens = ls.split(/\s+/);
    var match = null;
    for (var i = 0; i < tokens.length; i++) {
      if (tokens[i].indexOf(size + ':') === 0) { match = tokens[i]; break; }
    }
    if (!match) return;
    var count = parseInt(match.split(':')[1], 10);
    if (!(count >= 1 && count <= 9)) return;
    var text = 'Only ' + countLabel(count, size) + ' ' + sizeWord(size, count) + ' left';
    // Badge structure: blinking pulse dot + the text. That's it — no
    // rotating alert copy, no cross-fade. Mirrors the ALMOST_GONE pattern.
    var badge = document.createElement('span');
    badge.className = 'wc-vbadge wc-vbadge--low-stock wc-vbadge--' + contextMod + ' wc-low-stock-flag';
    badge.setAttribute('aria-label', text);
    var pulse = document.createElement('span');
    pulse.className = 'wc-vbadge__pulse';
    pulse.setAttribute('aria-hidden', 'true');
    badge.appendChild(pulse);
    badge.appendChild(document.createTextNode(text));
    // Swap with the existing same-context static badge if one exists, so the
    // visual position matches what was there before.
    var staticBadge = container.querySelector('.wc-vbadge--' + contextMod + ':not(.wc-low-stock-flag):not(.wc-vbadge--on-tile)');
    if (staticBadge) {
      staticBadge.setAttribute('data-wc-suppressed', '');
      staticBadge.style.display = 'none';
      staticBadge.parentNode.insertBefore(badge, staticBadge);
    } else if (contextMod === 'card') {
      var slot = container.querySelector('.card__information') || container.querySelector('.card__content') || container;
      slot.insertBefore(badge, slot.firstChild);
    } else {
      // PDP: container IS .wc-pdp-image-badge — append directly.
      container.appendChild(badge);
    }
  }

  // Read the currently-selected size from the PDP's variant radio buttons.
  // Returns the abbreviation (S/M/L/XL/2XL/XS) or null if not on a PDP / no
  // size radio is checked. Does NOT filter by WC_SIZES — if the customer
  // clicks XS on a PDP we want to show its low-stock badge, even though XS
  // is excluded from the broader cart-size signal.
  function getPdpSelectedSize() {
    var inputs = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < inputs.length; i++) {
      var name = inputs[i].getAttribute('name') || '';
      // Dawn-style names: "Size-template--..." or "options[Size]".
      if (name.indexOf('Size') > -1 || name.indexOf('options[Size]') > -1) {
        var v = inputs[i].value;
        return SIZE_MAP[v] || v;
      }
    }
    return null;
  }

  // PDP image badge re-render — uses the locally-clicked variant, NOT
  // effectiveSize(). Doesn't write to URL/sessionStorage/cart, so the
  // variant click stays scoped to this PDP visit only — cards on the
  // same page (related products, etc.) keep using effectiveSize(), and
  // navigating to a different PDP starts fresh from effectiveSize().
  // Fallback to effectiveSize() if no size radio is checked (edge case).
  function refreshPdpBadge() {
    var pdpSlot = document.querySelector('.wc-pdp-image-badge[data-wc-low-stock]');
    if (!pdpSlot) return;
    var size = getPdpSelectedSize() || effectiveSize();
    injectLowStockBadge(pdpSlot, size, 'pdp');
  }

  // Inject "Only N <smalls> left" everywhere the effective size matches a
  // card/PDP with 1-9 units in that size. Takes priority over static badges
  // (BESTSELLER / TRENDING / SELLING_FAST / ALMOST_GONE) — those get hidden
  // while low-stock is shown, restored when it isn't. Runs on every
  // applyTreatment call (filter change, cart update, bfcache, MutationObserver).
  function applyLowStockBadges() {
    var size = effectiveSize();
    // Card context: every card-wrapper that holds a quick-add button — covers
    // collection grid, cart-recs YMAL, related-products, fans-also-like,
    // more-from-artist, search, etc.
    document.querySelectorAll('.wc-quick-add').forEach(function (qa) {
      var card = qa.closest('[data-wc-sizes]');
      if (card) injectLowStockBadge(card, size, 'card');
    });
    // PDP slot reads its own variant selection, not effectiveSize, so a
    // size click here only affects this PDP — never bleeds to cards or
    // to the next PDP visit.
    refreshPdpBadge();
  }

  // Flag + relabel every quick-add for the effective size — but only where
  // that size is in stock (the card's data-wc-sizes). Cards with no size
  // data (stickers/magnets) and sold-out-in-size cards stay generic, so
  // the click handler keeps the normal size picker for them.
  function applyTreatment() {
    var size = effectiveSize();
    document.querySelectorAll('.wc-quick-add').forEach(function (qa) {
      // The collection trust card reuses .wc-quick-add purely for visual
      // consistency — it carries no product handle and its pill copy is
      // promotional ("1,500,000+ SOLD"), not a real button. Never relabel it.
      if (!qa.dataset.productHandle) return;
      var ok = false;
      if (size) {
        var card = qa.closest('[data-wc-sizes]');
        var sizes = card ? (' ' + (card.getAttribute('data-wc-sizes') || '') + ' ') : '';
        if (sizes.indexOf(' ' + size + ' ') > -1) ok = true;
      }
      if (ok) {
        qa.setAttribute('data-wc-quick-size', size);
      } else {
        qa.removeAttribute('data-wc-quick-size');
      }
      var btn = qa.querySelector('.wc-quick-add__btn');
      if (btn && !btn.hasAttribute('hidden') && btn.textContent !== '...') {
        btn.textContent = defaultBtnLabel(qa);
      }
    });
    applyLowStockBadges();
  }

  // Cart upsells: hide any recommendation that lacks the customer's preferred
  // size (the quick-add-button size = effectiveSize) in stock. If they added a
  // Large, drop recs with no Large available. Non-apparel recs (no
  // data-wc-sizes) and the no-preferred-size case stay visible. Reversible:
  // re-evaluated on every cart update via applyTreatment, and applies to
  // endless-scroll-appended recs through the same MutationObserver re-run.
  // Pull /cart.js, recompute the dominant size, re-apply the treatment.
  function fetchCartSize() {
    (window.wcCartJs ? window.wcCartJs() : fetch('/cart.js', { credentials: 'same-origin' }))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        currentCartSize = computeCartSize(cart);
        // Expose the cart-size signal for wc-cart-recs-more.js (the endless
        // loader) so its size phases match the quick-add button exactly.
        window.wcCartSize = currentCartSize;
        window.wcCartSizes = currentCartSizes;
        applyTreatment();
      })
      .catch(function () { applyTreatment(); });
  }

  function start() {
    init();
    applyTreatment();  // immediate — covers a collection filter in the URL
    fetchCartSize();   // async — layers in the cart-size signal
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-evaluate on any cart change, and when the collection filter changes.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, fetchCartSize);
  }
  document.addEventListener('wc:quickadd-refresh', applyTreatment);

  // Back-forward cache: tapping "back" to a collection restores a frozen
  // page snapshot and scripts don't re-run. If the shopper added to cart
  // in between, re-sync so the quick-add buttons reflect their new size.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) fetchCartSize();
  });

  // PDP-local variant-click handling: when the customer clicks a size on the
  // PDP, re-render JUST the .wc-pdp-image-badge with that variant's stock.
  // No URL/sessionStorage/cart writes — change is scoped to this PDP visit,
  // doesn't bleed to the related-products cards on the same page, doesn't
  // carry to the next PDP. Listens broadly on change events and bails fast
  // if the target isn't a size radio.
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.type !== 'radio') return;
    var name = e.target.getAttribute('name') || '';
    if (name.indexOf('Size') === -1) return;
    refreshPdpBadge();
  });

  
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        var hasNewQuickAdd = false;
        mutations[i].addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && (node.classList.contains('wc-quick-add') || node.querySelector('.wc-quick-add'))) {
            hasNewQuickAdd = true;
          }
        });
        if (hasNewQuickAdd) {
          init();
          applyTreatment();
          break;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
